import GoogleTagManager from "./services/googleTagManager";

export default GoogleTagManager;